function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError('Invalid attempt to spread non-iterable instance');
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === '[object Arguments]')
        return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }
        return arr2;
    }
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
import { version } from '../../../package.json';
import CryptoES from 'crypto-es';
import { XHR } from '@emav-util/network';
var AVStatistic = function () {
    function AVStatistic(env) {
        _classCallCheck(this, AVStatistic);
        var res = /(\(.*?\))/.exec(window.navigator.userAgent);
        this.kvs = [
            [
                'version',
                version
            ],
            [
                'platform',
                window.navigator.platform
            ],
            [
                'os_name',
                res[0]
            ],
            [
                'os_version',
                res[0]
            ],
            [
                'app_type',
                window.navigator.userAgent
            ],
            [
                'app_name',
                ''
            ],
            [
                'app_version',
                ''
            ],
            [
                'manufacturer',
                ''
            ],
            [
                'model',
                ''
            ],
            [
                'width',
                window.screen.width
            ],
            [
                'height',
                window.screen.height
            ],
            [
                'referrer',
                window.location.href
            ]
        ];
        this.domain = env === 'production' ? 'gateway.lvb.eastmoney.com' : 'gateway-qas.lvb.eastmoney.com';
    }
    _createClass(AVStatistic, [
        {
            key: 'print',
            value: function print() {
                console.log(',,,,,,,,,,,,,,,,,,,,,,,');
                console.log(this.kvs, this.domain);
            }
        },
        {
            key: 'emavStatistic',
            value: function emavStatistic(op) {
                try {
                    var action = 'EMAVStatistic';
                    var appId = '5b636cb3-6abe-4134-ab6d-948e83efe42a';
                    var timestamp = Math.floor(new Date().getTime() / 1000);
                    var kvs = [
                        [
                            'action',
                            action
                        ],
                        [
                            'appId',
                            appId
                        ],
                        [
                            'timestamp',
                            timestamp
                        ],
                        [
                            'op',
                            JSON.stringify(op)
                        ]
                    ].concat(_toConsumableArray(this.kvs));
                    var param = arrangeParameter(kvs);
                    var plainText = 'POST '.concat(this.domain, '/?').concat(param);
                    var av_param = aesEncrypt(plainText);
                    var sign = urlSign('POST '.concat(this.domain, '/?').concat(av_param), 'wz+gnpwp/vfmo2b6fzvf4q==');
                    var url = 'https://'.concat(this.domain, '/?action=').concat(action, '&appId=').concat(appId, '&timestamp=').concat(timestamp, '&sign=').concat(encodeURIComponent(sign));
                    console.log('[AVStatistic][emavStatistic]:', '\r\nplainText:', plainText, '\r\nsign:', sign, '\r\nurl:', url, '\r\nav_param:', av_param);
                    var xmlhttp = XHR();
                    xmlhttp.open('POST', url, true);
                    xmlhttp.setRequestHeader('av-param', av_param);
                    xmlhttp.send(null);
                } catch (error) {
                    console.log(error);
                }
                function aesEncrypt(plainText) {
                    var key = CryptoES.enc.Utf8.parse('4e79d792d071ef4e728e0f7d59be53ea');
                    var iv = CryptoES.enc.Utf8.parse('av.eastmoney.com');
                    var encrypted = CryptoES.AES.encrypt(plainText, key, {
                        iv: iv,
                        mode: CryptoES.mode.CBC,
                        padding: CryptoES.pad.ZeroPadding
                    });
                    return encrypted.toString();
                }
                function urlSign(plainText, key) {
                    var sign = '';
                    try {
                        sign = CryptoES.enc.Base64.stringify(CryptoES.HmacSHA256(plainText, key));
                    } catch (error) {
                        console.log(error);
                    }
                    return sign;
                }
                function arrangeParameter(kvs) {
                    var param = '';
                    try {
                        kvs.sort(function (i, j) {
                            if (i[0] < j[0]) {
                                return -1;
                            }
                            if (i[0] > j[0]) {
                                return 1;
                            }
                            if (i[0] === j[0]) {
                                return 0;
                            }
                        });
                        for (var i in kvs) {
                            var cur = kvs[i];
                            param += ''.concat(cur[0], '=').concat(encodeURIComponent(cur[1]), '&');
                        }
                        param = param.substring(0, param.length - 1);
                    } catch (error) {
                        console.log(error);
                    }
                    return param;
                }
            }
        }
    ]);
    return AVStatistic;
}();
export {
    AVStatistic as default
};